import {
	SET_CALENDAR,
	SET_CURRENT_CALENDAR,
	SET_ORDER_STATUS_CALENDAR,
	UPDATE_CURRENT_CALENDAR,
	RESET_CALENDAR,
} from './actionTypes';

const initialState = {
	list: null,
	current: {
		id: null,
		isToday: null,
		isHoliday: null,
		hasOrder: null,
		dateTime: null,
		persianDate: null,
		isEndOrderTime: null,
		delivered: null,
	},
};

export default (state = initialState, { type, payload }) => {
	switch (type) {
		case SET_CALENDAR:
			return {
				...state,
				list: payload,
			};
		case SET_CURRENT_CALENDAR:
			return {
				...state,
				current: {
					id: payload.id,
					isToday: payload.isToday,
					isHoliday: payload.isHoliday,
					hasOrder: payload.hasOrder,
					dateTime: payload.dateTime,
					persianDate: payload.persianDate,
					isEndOrderTime: payload.isEndOrderTime,
					delivered: payload.delivered || false,
				},
			};
		case UPDATE_CURRENT_CALENDAR:
			return {
				...state,
				current: {
					...state.current,
					...payload,
				},
			};
		case SET_ORDER_STATUS_CALENDAR:
			return {
				...state,
				list: payload.list,
				current: {
					...state.current,
					...payload.current,
				},
			};
		case RESET_CALENDAR:
			return initialState;
		default:
			return state;
	}
};
